import { useQuery } from '@tanstack/react-query'

import { ListPlaybooksResponse } from 'openapi/models/ListPlaybooksResponse'
import Services from 'services'

import { ListPlaybooksEndpointSchema } from '../../../schemas/playbook'

// In case we want to invalidate the query in the future.
export const PLAYBOOK_QUERY_KEY = 'playbooks'

export const useFetchPlaybooks = () => {
  return useQuery({
    queryKey: [PLAYBOOK_QUERY_KEY],
    queryFn: async () => {
      const frontendResponse =
        await Services.Backend.Get<ListPlaybooksResponse>('playbook/list')
      const parsedFormat = {
        ...frontendResponse,
        playbooks: frontendResponse.playbooks.map((playbook) => ({
          ...playbook,
          created_at: new Date(playbook.createdAt).toISOString(),
          modified_at: new Date(playbook.modifiedAt).toISOString(),
        })),
      }
      // Zod expects ISO 8601 strings, so we need to convert the dates just in case.
      const parsedResponse = ListPlaybooksEndpointSchema.parse(parsedFormat)
      return parsedResponse.playbooks
    },
    throwOnError: true,
  })
}
